<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>
            <span>
              {{ json_data.save_type == 'create' ? $t('menu.CommissionCreate') :
              $t('menu.CommissionEdit') }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            @click="json_data.save_type == 'create' ? showcreateDialog() : onUpdate()"
          >
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout
              row
              wrap
              pa-4
              style="background-color:#fff; margin-top:5px; border-radius:5px;"
            >
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'create'">
                      <v-select
                        required
                        :items="Branch_List"
                        :label="$t('branch')"
                        item-text="name"
                        item-value="code"
                        v-model="branchSelect"
                        hide-details
                      />
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'create'">
                      <v-select
                        required
                        :items="Department_List"
                        :label="$t('Department')"
                        item-text="name"
                        item-value="code"
                        v-model="departmentSelect"
                        hide-details
                      />
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'create'">
                      <v-select
                        :items="selectitems"
                        :item-text="$t('txt')"
                        item-value="val"
                        :label="$t('duration')"
                        v-model="ChoiceSelected"
                        @change="selectChoice()"
                      >
                        <template slot="item" slot-scope="{item}">
                          <div>{{ $t(item.txt) }}</div>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'create'">
                      <v-text-field
                        :label="$t('fromdate')"
                        type="date"
                        v-model="from_date"
                        hide-details
                      />
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'create'">
                      <v-text-field
                        :label="$t('todate')"
                        type="date"
                        v-model="to_date"
                        hide-details
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex md2 sm6 xs6 px-1 v-if="json_data.save_type == 'create'">
                      <v-select
                        required
                        :items="listcom"
                        item-text="text"
                        item-value="code"
                        label="ประเภทเบี้ยขยัน"
                        v-model="com_type"
                      />
                    </v-flex>
                    <v-flex
                      md2
                      sm3
                      xs6
                      px-1
                      v-if="com_type == 0 && json_data.save_type == 'create'"
                    >
                      <v-text-field
                        label="วันละ"
                        v-model="amount"
                        type="number"
                        hide-details
                        :min="0"
                        @change="amount = Math.max(Math.abs(amount),0)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      md2
                      sm3
                      xs6
                      px-1
                      v-if="com_type == 1 && json_data.save_type == 'create'"
                    >
                      <v-text-field
                        label="มาทำงานมากกว่า(วัน)"
                        v-model="totalday"
                        type="number"
                        hide-details
                        :min="0"
                        @change="totalday = Math.max(Math.abs(totalday),0)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      md2
                      sm3
                      xs6
                      px-1
                      v-if="com_type == 1 && json_data.save_type == 'create'"
                    >
                      <v-text-field
                        label="จ่ายงวดละ"
                        v-model="paycommission"
                        type="number"
                        hide-details
                        :min="0"
                        @change="paycommission = Math.max(Math.abs(paycommission),0)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'create'">
                      <v-btn block color="success" @click="process()">
                        <v-icon class="pr-2" size="16">fa-spinner</v-icon>
                        <span>{{$t('processor')}}</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
                 <v-layout row wrap pa-2>
                   <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'">
                      {{$t('DocumentID')}} : {{form_model.doc_no}}
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'">
                      {{$t('branch')}} : {{branchSelect}}
                    </v-flex> 
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'&& form_model.com_type==0" >
                      {{$t('Commission')}} : แบบรายวัน
                    </v-flex>

                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'&& form_model.com_type==1">
                      {{$t('Commission')}} : แบบงวด
                    </v-flex>
                 </v-layout>
                  <v-layout row wrap pa-2>

                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'">
                      {{$t('fromdate')}} : {{formatdate(from_date)}}
                      
                    </v-flex>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'">
                       {{$t('todate')}} : {{formatdate(to_date)}}
                     
                    </v-flex>
                  </v-layout>

                   <v-layout row wrap pa-2>
                    <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'">
                    <v-text-field
                    :label="$t('effectdate')"
                    type="date"
                    v-model="form_model.effect_date"
                  ></v-text-field>
                    </v-flex>
                     <v-flex md2 sm6 xs12 px-1 v-if="json_data.save_type == 'update'">
                    <v-text-field
                    :label="$t('remark')"
                    type="text"
                    v-model="form_model.remark"
                  ></v-text-field>
                    </v-flex>
                  </v-layout>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              pa-4
              class="justify-center"
              style="background-color:#fff; margin-top:5px; border-radius:5px;"
              v-if="showdisplay"
            >
              <v-flex xs12 class="scroll-able" v-if="form_model.com_type == 0">
                <table>
                  <thead>
                    <tr>
                      <th nowrap class="text-left topic-color" width="200">{{$t('employee_code')}}</th>
                      <th nowrap class="text-left topic-color" width="250">{{$t('name')}}</th>
                      <th nowrap class="text-left topic-color" width="200">{{$t('Totalday')}}</th>
                      <th nowrap class="text-left topic-color" width="200">{{$t('TotalAmount')}}</th>
                      <th nowrap class="text-left topic-color" width="200">{{$t('Total')}}</th>
                    </tr>
                  </thead>
                  <tbody class="coco-list-hover" v-for="(items,i) in set_json" :key="i">
                    <tr style="text-align:left;background-color:#fcf8e3;" class="border_bottom">
                      <td colspan="4" style="padding:15px;">{{i}}</td>
                    </tr>
                    <tr
                      v-for="(item,i) in items"
                      :key="i"
                      style="text-align:center"
                      class="border_bottom"
                    >
                      <td>{{item.emp_code}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.com_day}}</td>
                      <td>
                        <v-text-field
                          v-model="item.amount"
                          type="number"
                          :min="0"
                          @change="item.amount = Math.max(Math.abs(item.amount),0)"
                          @input="sumtotal(item, i)"
                        ></v-text-field>
                      </td>
                      <td>{{item.total_amount}}</td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>

              <v-flex xs12 class="scroll-able" v-if="form_model.com_type == 1">
                <table>
                  <thead>
                    <tr>
                      <th nowrap class="text-left topic-color" width="250">{{$t('employee_code')}}</th>
                      <th nowrap class="text-left topic-color" width="250">{{$t('name')}}</th>
                      <th nowrap class="text-left topic-color" width="250">{{$t('Totalday')}}</th>
                      <th nowrap class="text-left topic-color" width="250">{{$t('TotalAmount')}}</th>
                    </tr>
                  </thead>
                  <tbody class="coco-list-hover" v-for="(items,i) in set_json" :key="i">
                    <tr style="text-align:left;background-color:#fcf8e3;" class="border_bottom" >
                      <td colspan="4" style="padding:15px;">{{i}}</td>
                    </tr>
                    <tr
                      v-for="(item,i) in items"
                      :key="i"
                      style="text-align:center"
                      class="border_bottom"
                    >
                      <td>{{item.emp_code}}</td>
                        <td class="text-left">{{item.name}}</td>
                      <td>{{item.com_day}}</td>
                      <td style="padding-right:15px;">
                        <v-text-field
                          v-model="item.total_amount"
                          type="number"
                          :min="0"
                          @change="item.total_amount = Math.max(Math.abs(item.total_amount),0)"
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? showcreateDialog() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar
      v-model="snack_model.status"
      :timeout="3500"
      :top="'top'"
      :right="'right'"
      :color="snack_model.type"
    >
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout row justify-center>
      <v-dialog v-model="docDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('menu.CommissionCreate')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    readonly
                    :label="$t('DocumentID')"
                    required
                    v-model="form_model.doc_no"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('Document creation date')"
                    type="date"
                    v-model="form_model.doc_date"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('effectdate')"
                    type="date"
                    v-model="form_model.effect_date"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('remark')" v-model="form_model.remark"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="docDialog = false">ยกเลิก</v-btn>
            <v-btn color="blue darken-1" flat @click="onSave()">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import Utils from "@/utils/";
import DocumentService from "@/services/DocumentService";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      this.doNewGuid();
      if (val.data != null) {
        // this.form_model = val.data;
        this.getBranch();
        console.log(val.data.docNo);
        this.getDetail(val.data.docNo);
      } else {
         this.getBranch();
        this.$refs.form.resetValidation();
      }
    },
  },
  data: () => ({
    selectitems: [
      { txt: "None", val: "" },
      { txt: "ThisMount", val: 0 },
      { txt: "ThisWeek", val: 1 },
      { txt: "Today", val: 2 },
      { txt: "LastWeek", val: 3 },
      { txt: "LastMount", val: 4 },
    ],
    paycommission: 0,
    totalday: 0,
    amount: 0,
    com_type: 0,
    ChoiceSelected: "",
    from_date: "",
    to_date: "",
    docDialog: false,
    form_valid: false,
    showdisplay: false,
    listcom: [
      { code: 0, text: "แบบรายวัน" },
      { code: 1, text: "แบบงวด" },
    ],
    dateTime: [
      {
        date_time: "",
      },
    ],
    form_model: {
      doc_no: "",
      doc_date: new Date().toISOString().substr(0, 10),
      effect_date: "",
      remark: "",
      creator_code: localStorage._usercode,
      from_date: "",
      to_date: "",
      branch_code: "",
      department_code: "",
      com_type: 0,
      details: [],
    },
    form_rules: {
      date_time: [(v) => !!v || "do not empty."],
      usercode: [(v) => !!v || "do not empty."],
      doc_no: [(v) => !!v || "do not empty."],
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    arr: [],
    set_json: [],
  }),
  created: function () {
    this.doNewGuid();
  },
  mounted: function () {
    this.getBranch();
  },
  computed: {
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate",
      "SearchData",
    ]),
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols",
    ]),
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      },
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      },
    },
  },
  methods: {
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),

    selectChoice() {
      if (this.ChoiceSelected == 0) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.from_date = this.selectedformatDates(firstDay);
        this.to_date = this.selectedformatDates(lastDay);
        // this.process();
      } else if (this.ChoiceSelected == 1) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first + 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        this.from_date = this.selectedformatDates(firstday);
        this.to_date = this.selectedformatDates(lastday);
      } else if (this.ChoiceSelected == 2) {
        var curr = new Date();
        this.from_date = this.selectedformatDates(curr);
        this.to_date = this.selectedformatDates(curr);
      } else if (this.ChoiceSelected == 3) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first - 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        if (curr.setDate(first) > curr.setDate(last)) {
          this.from_date = this.selectedformatDates(lastday);
          this.to_date = this.selectedformatDates(firstday);
        } else if (curr.setDate(first) < curr.setDate(last)) {
          this.from_date = this.selectedformatDates(firstday);
          this.to_date = this.selectedformatDates(lastday);
        }
      } else if (this.ChoiceSelected == 4) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
        this.from_date = this.selectedformatDates(firstDay);
        this.to_date = this.selectedformatDates(lastDay);
      } else {
        this.from_date = "";
        this.to_date = "";
      }
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    process() {
      if (
        this.from_date == "" ||
        this.to_date == "" ||
        this.SelectBranch == "All"
      ) {
        this.showSnackBar("กรุณาเลือกสาขาและวันที่", "error");
      } else {
        let searchVal = "";
        if (this.Search_data == undefined) {
          searchVal = "";
        } else {
          searchVal = this.Search_data;
        }

        console.log(this.totalday)
        DocumentService.getCommissionDoc(
          this.SelectBranch,
          this.SelectDepartment,
          this.SelectPosition,
          searchVal,
          this.from_date,
          this.to_date,
          this.totalday
        )
          .then((res) => {
            this.arr = [];
            let v = this;
            this.set_json = res.data;
            console.log(res.data);
            res.data.forEach((element) => {
              //console.log(element)
              if (v.com_type == 0) {
                v.arr.push({
                  branch: element.branch,
                  com_day: element.com_day,
                  department: element.department,
                  emp_code: element.emp_code,
                  name: element.name,
                  amount: v.amount,
                  total_amount: v.amount * element.com_day,
                });
              }
              if (v.com_type == 1) {
                v.arr.push({
                  branch: element.branch,
                  com_day: element.com_day,
                  department: element.department,
                  emp_code: element.emp_code,
                  name: element.name,
                  amount: v.amount,
                  total_amount: v.paycommission,
                });
              }
            });
            this.form_model.com_type = this.com_type;
            this.set_json = this.groupBy(v.arr, "department");
            this.showdisplay = true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    groupBy(array, key) {
      return array.reduce((result, currentValue) => {
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );

        return result;
      }, {});
    },
    getDetail(param) {
      DocumentService.getCommissionDocDetailByDocNo(param)
        .then((res) => {
          console.log(res.data);
          //this.form_model = this.data;
          this.com_type = res.data.com_type;
          this.from_date = res.data.from_date;
          this.to_date = res.data.to_date;
          this.branchSelect = res.data.branch_code; 
          this.departmentSelect = res.data.department_code; 
          this.form_model.doc_no = res.data.doc_no;
          this.form_model.effect_date = res.data.effect_date;
          this.form_model.remark = res.data.remark;
          this.form_model.doc_date = res.data.doc_date;
           this.form_model.com_type = res.data.com_type;

          this.set_json = this.groupBy(res.data.details, "department_name"); 
          this.showdisplay = true;
          console.log(this.set_json);
        })
        .catch((err) => {
          this.showSnackBar(err.response.data, "error");
        });
      // this.form_model = this.data;
      // this.com_type = this.form_model.com_type;
      // this.from_date = this.form_model.from_date;
      // this.to_date = this.form_model.to_date;
      // this.showdisplay = true;
      // this.set_json = this.form_model.details;

      console.log(this.form_model);
    },

    sumtotal(item, index) {
      console.log(item);
      item.total_amount = item.com_day * item.amount;
    },
    closeDialog() {
      this.$emit("close-dialog");
      this.clearForm();
      this.doNewGuid();
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    clearForm() {
      this.json_checkin = [];
      (this.form_model = {
        doc_no: "",
        doc_date: new Date().toISOString().substr(0, 10),
        effect_date: "",
        remark: "",
        creator_code: localStorage._usercode,
        from_date: "",
        to_date: "",
        branch_code: "",
        department_code: "",
        com_type: 0,
        details: [],
      }),
        (this.set_json = []);
      this.showdisplay = false;
      this.paycommission = 0;
      this.totalday = 0;
      this.amount = 0;
      this.com_type = 0;
      this.ChoiceSelected = "";
      this.from_date = "";
      this.to_date = "";
      this.checkperson = [];
      this.name = [];
      (this.branch = ""), (this.department = ""), (this.Employee_list = []);
      this.Employee_items = [];
      this.isChecked = false;
      console.log("ddddddddddd", this.checkperson);
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    doNewGuid() {
      this.form_model.doc_no = Utils.newGuid("CM");
    },
    showcreateDialog() {
      if (
        this.from_date == "" ||
        this.from_date == undefined ||
        this.to_date == "" ||
        this.from_date == undefined ||
        this.SelectBranch == ""
      ) {
      } else {
        this.docDialog = true;
      }
    },
    onSave() {
      let department = "";
      this.form_model.branch_code = this.SelectBranch;
      this.form_model.from_date = this.from_date;
      this.form_model.to_date = this.to_date;
      if (this.SelectDepartment == "All" || this.SelectDepartment == "") {
        this.form_model.department_code = "";
      } else {
        this.form_model.department_code = this.SelectDepartment;
      }
      for (var set in this.set_json) {
        this.set_json[set].forEach((element) => {
          this.form_model.details.push({
            emp_code: element.emp_code,
            com_day: element.com_day,
            amount: element.amount,
            total_amount: element.total_amount,
          });
        });
      }
      console.log(this.form_model);
      DocumentService.createCommission(this.form_model)
        .then((res) => {
          this.showSnackBar("save success", "success");
          this.closeDialog();
          this.docDialog = false;
        })
        .catch((err) => {
          this.showSnackBar(err.response.data, "error");
        });
    },
    onUpdate() {
      let department = "";
      this.form_model.branch_code = this.SelectBranch;
      this.form_model.from_date = this.from_date;
      this.form_model.to_date = this.to_date;
      if (this.SelectDepartment == "All" || this.SelectDepartment == "") {
        this.form_model.department_code = "";
      } else {
        this.form_model.department_code = this.SelectDepartment;
      }
       for (var set in this.set_json) {
        this.set_json[set].forEach((element) => {
          this.form_model.details.push({
            emp_code: element.emp_code,
            com_day: element.com_day,
            amount: element.amount,
            total_amount: element.total_amount,
          });
        });
      }
      console.log(this.form_model);
       DocumentService.updateCommission(this.form_model)
            .then(res => {
              this.showSnackBar('save success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
    },
  },
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
.v-card__text {
  padding: 0px !important;
}
table,
tr.border_bottom td {
  border-bottom: 1px solid rgb(204, 204, 204);
  height: 40px;
}
th {
  height: 40px;
  font-size: 16px;
}
.topic-color {
  background-color: #1976d2;
  color: #ffff;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>